import React from 'react';
import { Box } from '@mui/material';
import { mathSourceLiteral } from './quoteDOM';

/** Keep the complete formula readable while the math engine loads or fails. */
export default function MathFallback({ text, display = false, source }) {
  const literal = mathSourceLiteral(text, display, source);
  return <Box component="span" data-math-fallback="true" data-math-source={literal} sx={{ display: display ? 'block' : 'inline', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{literal}</Box>;
}
